import { PeertjeLabsStevenPage } from '../containers/steven-page'

export default PeertjeLabsStevenPage
